<template>
  <div>
    <b-toast id="front-version-check" variant="info" no-auto-hide>
      <template #toast-title>
        <translate>Notice</translate>
      </template>
      <p v-translate="{productName: this.$gettext('IAT Manager')}">There is a new version of the %{productName}, please reload all currently open windows/tabs to get the new version with the latest changes.</p>
      <p class="mb-0">
        <span v-translate="{currentFrontVersion: this.currentFrontVersion}">Current version: <em>%{currentFrontVersion}</em></span><br>
        <span v-translate="{availableFrontVersion: this.availableFrontVersion}">Available version: <strong>%{availableFrontVersion}</strong></span>
      </p>
    </b-toast>
  </div>
</template>

<script>
export default {
  name: 'FrontVersionChecker',
  data() {
    return {
      currentFrontVersion: null,
      availableFrontVersion: null,
      updateNotice: false,
      intervalCheckFrontVersionInterval: 5 * 60 * 1000,
      intervalCheckFrontVersion: null
    }
  },
  created() {
    this.checkFrontVersion()
    this.intervalCheckFrontVersion = setInterval(() => {
      this.checkFrontVersion()
    }, this.intervalCheckFrontVersionInterval)
  },
  methods: {
    checkFrontVersion() {
      this.$http.get('/static/version.json')
        .then(response => {
          this.availableFrontVersion = response.body.version
          if (this.currentFrontVersion === null) {
            this.currentFrontVersion = this.availableFrontVersion
          } else if (this.currentFrontVersion !== this.availableFrontVersion) {
            if (this.updateNotice === false) {
              this.$bvToast.show('front-version-check')
              this.updateNotice = true
            }
          }
        })
    }
  }
}
</script>
